import { render, staticRenderFns } from "./DesignSystemMain.vue?vue&type=template&id=3e87392a"
import script from "./DesignSystemMain.vue?vue&type=script&lang=js"
export * from "./DesignSystemMain.vue?vue&type=script&lang=js"
import style0 from "./DesignSystemMain.vue?vue&type=style&index=0&id=3e87392a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports